import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../models/api';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class AuthService {
    constructor(
        private router: Router,
        private http: HttpClient) { }

    login(data: any): Observable<ApiResponse<any>> {
        return this.http.post<ApiResponse<any>>(environment.API_BASE_URL + "/api/login", data);
    }

    forgotPassword(data: any): Observable<ApiResponse<any>> {
        return this.http.post<ApiResponse<any>>(environment.API_BASE_URL + "/api/forgot-password", data);
    }
}
